import React, { useEffect } from "react";
import { requireEnv } from "../api";
import { Button } from "@mui/material";

export const RedirectControlSurvey = (props: { canvasId: string }) => {
    const CONTROL_SURVEY_URL = requireEnv("REACT_APP_CONTROL_SURVEY_URL");

    useEffect(() => {
        if (!props.canvasId) return;
        window.location.href = `${CONTROL_SURVEY_URL}?canvasid=${props.canvasId}`;
    }, [props.canvasId]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            Redirecting to Qualtrics...
            <div style={{ marginTop: '20px', opacity: 0.8 }}>
                If you are not automatically redirected, please click <Button style={{
                    
                }} onClick={() => window.location.href = `${CONTROL_SURVEY_URL}?canvasid=${props.canvasId}`}>
                        here
                </Button>
            </div>
        </div>
    );
}